import React, { useEffect } from 'react';
import classes from './PropertyRequestDetailModal.module.css';
import ModalSkeleton from '../ModalSkeleton';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { enquiryTypeOptions, furnishingOptions } from '../../constant/commonData';
import ShowMoreShowLessText from '../../Component/ShowMoreShowLess/ShowMoreShowLessText';
import { useMarkAsSeenPropertyRequestMutation } from '../../store/apiSlice/apiSlice';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const LabelAndValue = ({ label, value, className = '' }) => {
  return (
    <div className={[classes.labelValue, className].join(' ')}>
      <span className={classes.label}>
        {label}
        {': '}
      </span>
      <span className={classes.value}>{value ?? '---'}</span>
    </div>
  );
};

function PropertyRequestDetailModal({ show, setShow, data, isSeen, type, t }) {
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const [markAsReadFn] = useMarkAsSeenPropertyRequestMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSeen) {
      markAsReadFn({
        id: data?._id,
        type: type
      });
    }
  }, [isSeen]);

  return (
    <>
      <style>
        {`
        @media (max-width: 1220px) {
        .modalSkeleton_modal__uqB-E .modal-content{
        width: 90% !important;
      
        }}

        @media (max-width: 1440px) {
         .modalSkeleton_modal__uqB-E{
       padding-block: 50px !important;
       }
        }
        @media (max-width: 768px) {
        .modal.show .modal-dialog{
       margin: 50px auto !important;
        }
      
     
       .modalSkeleton_modal__uqB-E{
       padding-block: 150px !important;
       }
        }
         @media (max-width: 500px) {
        .modalSkeleton_modal__uqB-E .modal-content{
        width: 100% !important;}}
        `}
      </style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        modalClass={classes.main}
        borderRadius={'0px'}
        width={'1200px'}
        header={
          type === 'property-request' ? t('modal.propertyRequestDetail') : t('modal.messageDetail')
        }
        headerClass={classes.header}>
        {type === 'property-request' && (
          <div>
            <Row className={classes?.row}>
              <Col md={12}>
                <h5>{t('modal.title')}</h5>
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.fullName')} value={data?.fullName} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.email')} value={data?.email} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.phoneNumber')} value={data?.phoneNumber} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.contactMethod')} value={data?.contactMethod} />
              </Col>
              <Col md={12}>
                <h5>{t('modal.propertyRequirement')}</h5>
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.enquiryType')}
                  value={enquiryTypeOptions?.find((e) => e?.value == data?.enquiryType)?.label}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.propertyType')}
                  value={data?.propertyType?.title?.[selectedLanguage]}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.city')} value={data?.city} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.areaStreet')} value={data?.street} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.budget')} value={data?.budget} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.area')} value={data?.area} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.rooms')} value={data?.bedrooms} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.bathrooms')} value={data?.bathrooms} />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.furnishing')}
                  value={furnishingOptions?.find((e) => e?.value == data?.furnishing)?.label}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.floorLevel')}
                  value={data?.floorLevel?.[selectedLanguage]}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.propertyStatus')}
                  value={data?.propertyStatus?.[selectedLanguage]}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.parkingSpace')}
                  value={data?.parkingSpace?.[selectedLanguage]}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t('modal.viewAndOrientation')} value={data?.bathrooms} />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.interiorAmenities')}
                  value={data?.interiorAmenities
                    ?.map((e) => e?.title?.[selectedLanguage])
                    ?.join(', ')}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t('modal.exteriorAmenities')}
                  value={data?.exteriorAmenity
                    ?.map((e) => e?.title?.[selectedLanguage])
                    ?.join(', ')}
                />
              </Col>
              <Col md={12}>
                <h5>{t('modal.additionalRequests')}</h5>
              </Col>
              <Col md={12}>
                <LabelAndValue
                  label={t('modal.description')}
                  value={<ShowMoreShowLessText text={data?.requests} />}
                  className={classes.description}
                />
              </Col>
            </Row>
          </div>
        )}

        {/* 'Inquiry/Message Detail' */}
        {type !== 'property-request' && (
          <div>
            <Row className={classes?.row}>
              <Col md={12}>
                <h5>{t('modal.messageDetail')}</h5>
              </Col>

              {data?.type && (
                <Col md={6}>
                  <LabelAndValue label={t('modal.type')} value={data?.type} />
                </Col>
              )}
              <Col md={6}>
                <LabelAndValue label={t('modal.inquiryType')} value={data?.inquiryType} />
              </Col>
              {data?.type && (
                <Col md={6}>
                  <LabelAndValue
                    label={`Show ${data?.type}`}
                    value={
                      <span
                        className="c-p"
                        onClick={() => {
                          const route = `/${
                            data?.type === 'property' ? data?.type : `${data?.type}s`
                          }/${data?.entity?.slug}`;
                          navigate(route);
                        }}>
                        {t('modal.clickToView')} {data?.type}
                      </span>
                    }
                  />
                </Col>
              )}
              <Col md={6}>
                <LabelAndValue label={t(`modal.name`)} value={data?.name} />
              </Col>
              <Col md={6}>
                <LabelAndValue label={t(`modal.email`)} value={data?.email} />
              </Col>

              <Col md={6}>
                <LabelAndValue label={t(`modal.phone`)} value={data?.phone} />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t(`modal.contactMethod`)}
                  value={data?.preferredContactMethod}
                />
              </Col>
              <Col md={6}>
                <LabelAndValue
                  label={t(`modal.createdAt`)}
                  value={moment(data?.createdAt).format('lll')}
                />
              </Col>
              <Col md={12}>
                <LabelAndValue label={t(`modal.message`)} value={data?.message} />
              </Col>
            </Row>
          </div>
        )}
      </ModalSkeleton>
    </>
  );
}

export default PropertyRequestDetailModal;
